/**
 * Variant picker UX:
 * - keeps the "Size: W31 L32" heading in step with the chosen option.
 * - flags the product with .vp-sold-out when the chosen variant is sold out, so the
 *   Add To Cart row can give way to "Notify Me When Available".
 */
document.addEventListener('change', (evt) => {
  const input = evt.target;
  if (!input.matches || !input.matches('variant-picker .js-option')) return;

  const selector = input.closest('.option-selector');
  const selectedText = selector && selector.querySelector('.js-selected-text');
  if (!selectedText) return;

  const label = input.nextElementSibling;
  selectedText.textContent = (label && label.dataset.display) || input.value;
});

/**
 * Sorts the remaining size grids (waist/leg and "Size N" are already sorted in Liquid):
 * letter sizes (Small, M, XL, 2XL...) by size, otherwise by the first number in each value
 * ("Waist 32\"", "Medium - Size 8", "1.5 Inch", "€20.00"). Left alone if any value doesn't fit.
 */
const LETTER_SIZE_RANKS = {
  xxs: 0, xs: 1, s: 2, small: 2, m: 3, medium: 3, l: 4, large: 4, xl: 5,
  xxl: 6, '2xl': 6, xxxl: 7, '3xl': 7, '4xl': 8, '5xl': 9, '6xl': 10
};

const getSizeKeys = (values) => {
  const letterKeys = values.map((v) => LETTER_SIZE_RANKS[v.trim().toLowerCase()]);
  if (letterKeys.every((k) => k !== undefined)) return letterKeys;

  // Prefer the number after "Size" ("2XL - Size 11" sorts as 11), else the first number.
  const numberKeys = values.map((v) => {
    const clean = v.replace(/,/g, '');
    const match = clean.match(/size\s*:?\s*(\d+(\.\d+)?)/i) || clean.match(/(\d+(\.\d+)?)/);
    return match ? parseFloat(match[1]) : undefined;
  });
  return numberKeys.every((k) => k !== undefined) ? numberKeys : null;
};

document.querySelectorAll('variant-picker .option-selector__btns--grid').forEach((grid) => {
  const labels = Array.from(grid.querySelectorAll('.opt-label'));
  if (labels.length < 2 || labels.some((label) => label.style.order)) return;

  const keys = getSizeKeys(labels.map((label) => label.previousElementSibling.value));
  if (!keys) return;

  labels.forEach((label, index) => {
    label.style.order = Math.round(keys[index] * 100);
  });
});

const setSoldOutState = (picker, variant) => {
  const product = picker.closest('.js-product');
  if (!product) return;
  product.classList.toggle('vp-sold-out', !!variant && !variant.available);

  // "in stock" / "out of stock" label by the product title (snippets/stock-status.liquid).
  if (variant) {
    product.querySelectorAll('.js-stock-status-in').forEach((el) => { el.hidden = !variant.available; });
    product.querySelectorAll('.js-stock-status-out').forEach((el) => { el.hidden = variant.available; });
  }

  // The bundles Add To Cart (sf9__product_accessories.js) is a one-off clone of the original
  // button, so it keeps whatever state the page loaded with. Keep it in step with the chosen variant.
  const singleAtc = product.querySelector('.custom__single-add-to-cart');
  if (!singleAtc || !variant) return;

  singleAtc.disabled = !variant.available;
  if (variant.available) {
    singleAtc.style.removeProperty('display');
    singleAtc.textContent = singleAtc.dataset.addToCartText || singleAtc.textContent;
  }
};

document.addEventListener('on:variant:change', (evt) => {
  if (evt.target.matches('variant-picker')) setSoldOutState(evt.target, evt.detail.variant);
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('variant-picker').forEach((picker) => {
    setSoldOutState(picker, picker.variant);
  });
});
